// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { createSelector } from 'reselect';

export const selectedCountryInfoSelector = createSelector(
    (state: any) => state,
    (res: { countryInfo: any }) => {
        return res.countryInfo;
    }
);

export const countriesListSelector = createSelector(
    (state: any) => state,
    res => res.countries && res.countries.list || []
);